var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Chuyển sang nghỉ học: " + _vm.fullName,
            visible: _vm.dialogVisible,
            width: "500px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "20vh",
            "custom-class": "sk-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "sk-dialog-content" }, [
            _c(
              "div",
              { staticClass: "sk-panel" },
              [
                _c("div", { staticClass: "sk-panel-head" }, [
                  _c(
                    "div",
                    {
                      staticClass: "sk-panel-icon",
                      staticStyle: {
                        background: "linear-gradient(135deg, #fbbf24, #d97706)",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-time" })]
                  ),
                  _c("div", [
                    _c("p", { staticClass: "sk-panel-title" }, [
                      _vm._v("Xác nhận nghỉ học"),
                    ]),
                    _c("p", { staticClass: "sk-panel-subtitle" }, [
                      _vm._v("Chọn ngày chính thức nghỉ học cho học sinh."),
                    ]),
                  ]),
                ]),
                _c(
                  "el-form",
                  {
                    ref: "dataInput",
                    attrs: { model: _vm.dataInput, "label-width": "160px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Chọn ngày nghỉ học", prop: "date" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            format: "dd-MM-yyyy",
                            placeholder: "Chọn ngày",
                            clearable: false,
                            "picker-options": _vm.pickerOptions,
                          },
                          model: {
                            value: _vm.dataInput.date,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "date", $$v)
                            },
                            expression: "dataInput.date",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer sk-dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-cancel",
                  attrs: { type: "danger", size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialog()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("button.close")))]),
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-save",
                  attrs: {
                    type: "success",
                    size: "medium",
                    loading: _vm.loadingButton,
                    mini: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("button.save")))]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }